"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGreeting = void 0;
var getGreeting = function (
// eslint-disable-next-line camelcase
_a) {
    var given_name = _a.given_name, family_name = _a.family_name, email = _a.email;
    return ({
        short: getShort(given_name, family_name, trimEmail(email)),
        full: getFull(given_name, family_name, trimEmail(email)),
    });
};
exports.getGreeting = getGreeting;
var getShort = function (given, family, email) {
    if (given !== undefined)
        return given;
    if (family !== undefined)
        return family;
    return email;
};
var getFull = function (given, family, email) {
    if (given !== undefined && family !== undefined)
        return "".concat(given, " ").concat(family);
    if (given !== undefined)
        return given;
    if (family !== undefined)
        return family;
    return email;
};
var trimEmail = function (email) { return email.split("@")[0]; };
